import React from "react";
import { Plus, Search, Sparkles } from "lucide-react";
import ConversationListItem from "./ConversationListItem";

export default function ConversationList({
  inboxItems,
  searchQuery,
  setSearchQuery,
  onSelectConversation,
  onNewGroup,
  onlineFriends,
}) {
  return (
    <aside className="flex max-h-[min(360px,42vh)] min-h-0 w-full min-w-0 shrink-0 flex-col border-b border-white/10 bg-[#0b1019] lg:max-h-none lg:border-b-0 lg:border-r">
      <div className="flex h-full min-h-0 min-w-0 flex-col">
        <div className="px-5 pt-5 pb-4 border-b border-white/10">
          <div className="flex items-center justify-between gap-3">
            <div>
              <h1 className="text-[1.15rem] font-semibold tracking-tight text-white">Messages</h1>
              <p className="mt-0.5 text-xs text-white/50">Your inbox</p>
            </div>
            <button
              onClick={onNewGroup}
              className="h-9 px-3 rounded-2xl border border-white/12 bg-white/[0.04] hover:bg-white/[0.08] text-white/80 transition inline-flex items-center gap-1.5"
              aria-label="Create group chat"
            >
              <Plus size={15} />
              <span className="text-xs font-medium">New</span>
            </button>
          </div>

          <div className="mt-4 relative">
            <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/42" />
            <input
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search"
              className="w-full h-10 rounded-2xl border border-white/10 bg-white/[0.03] pl-9 pr-3 text-sm text-white placeholder:text-white/35 outline-none focus:border-white/20 focus:bg-white/[0.05] transition"
            />
          </div>
        </div>

        <div className="flex-1 overflow-y-auto fc-scroll px-3 py-3">
          {inboxItems.length === 0 ? (
            <div className="mx-2 mt-2 rounded-3xl border border-white/10 bg-white/[0.03] p-4">
              <div className="flex items-center gap-2 text-white/80">
                <Sparkles size={16} className="text-white/70" />
                <span className="text-sm font-medium">No conversations yet</span>
              </div>
              <p className="mt-1 text-xs text-white/48">Find friends or create a group to start messaging.</p>
            </div>
          ) : (
            inboxItems.map((item) => (
              <ConversationListItem
                key={item.id}
                item={item}
                isOnline={item.type === "dm" ? onlineFriends.has(item.keyId) : false}
                onClick={() => onSelectConversation(item)}
              />
            ))
          )}
        </div>
      </div>
    </aside>
  );
}
